import { v4 } from 'uuid'
import { getImageUrlFromName } from '../../../util'

const StayFeaturedLayout = ({ layout, value }) => {
  // let imageUrl = getImageUrlFromName(layout.icon_name)
  console.log('>>>>>>>>known for', layout)

  return (
    <div
      style={{
        padding: '16px 20px 24px 20px',
        background: layout.color ? `#${layout.color}` : '',
        // background: '#00ff00',
      }}
    >
      <div
        style={{
          // marginTop: '10px',
          marginBottom: '16px',
          textAlign: 'left',
          color: 'var(--gray100)',
        }}
      >
        <p className="title2">{layout.display_name}</p>
      </div>
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'flex-start',
        }}
      >
        {value.map((item) => {
          console.log('>>>>>>>image', item.icon_name)
          return (
            <div
              style={{
                textAlign: 'center',
                width: '87px',
                height: '118px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <img
                style={{
                  width: '48px',
                  height: '48px',
                }}
                src={getImageUrlFromName(item.icon_name)}
                alt="icon"
              ></img>
              <p
                className="body3"
                key={v4()}
                style={{ marginTop: '0px', lineHeight: '150%', width: '60px' }}
              >
                {item.display_name}
              </p>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default StayFeaturedLayout
